import { createContext } from 'react';

export const AritoFormV2Context = createContext<any>(null);
